function unwrapShopifyBlockWrappers(wrapperEl) {
  Array.prototype.slice.call(wrapperEl.children).forEach(function (child) {
    if (child.classList && child.classList.contains('shopify-block')) {
      while (child.firstChild) {
        wrapperEl.insertBefore(child.firstChild, child);
      }
      wrapperEl.removeChild(child);
    }
  });
}

function initNewLandingImagesSliderWithData(root) {
  if (typeof Swiper === 'undefined') return;

  var scope = root && root.querySelectorAll ? root : document;
  var sliders = scope.querySelectorAll('.new-landing-images-slider-with-data__swiper');

  sliders.forEach(function (el) {
    if (el.swiper) return;

    var wrapperEl = el.querySelector('.swiper-wrapper');
    if (wrapperEl) unwrapShopifyBlockWrappers(wrapperEl);

    new Swiper(el, {
      slidesPerView: 2.1,
      spaceBetween: 10,
      slidesOffsetBefore: 16,
      slidesOffsetAfter: 16,
      grabCursor: true,
      mousewheel: {
        forceToAxis: true,
        sensitivity: 1,
        releaseOnEdges: true,
      },
      pagination: {
        el: el.querySelector('.swiper-pagination'),
        clickable: true,
      },
      breakpoints: {
        0: {
          slidesPerView: 1.7,
          spaceBetween: 12,
          slidesOffsetBefore: 16,
          slidesOffsetAfter: 16,
        },
        750: {
          slidesPerView: 2.1,
          spaceBetween: 16,
          slidesOffsetBefore: 16,
          slidesOffsetAfter: 16,
        },
      },
    });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initNewLandingImagesSliderWithData(document);
});

document.addEventListener('shopify:section:load', function (event) {
  initNewLandingImagesSliderWithData(event.target);
});

document.addEventListener('shopify:block:select', function (event) {
  initNewLandingImagesSliderWithData(document);
});

if (document.readyState === 'complete' || document.readyState === 'interactive') {
  initNewLandingImagesSliderWithData(document);
}
